export enum SiteType {
    Webcams = 'WEBCAMS',
    Adult = 'ADULT',
    Dating = 'DATING',
    Casion = 'CASINO'
}

export function translateSiteType(type: SiteType): string {
    return type;
}
